import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { RegisterForm } from '@old/features/public/register/register-form';

export function PlastarRegisterPage() {
  return (
    <AuthLayoutComponent variant="plastar">
      <RegisterForm referralSource="plastar" />
    </AuthLayoutComponent>
  );
}
